<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rs1X6n/tc-custom/9781400210664.jpg?1728851606889" alt="This image is the cover for the book Restoring the Soul of Business"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Restoring the Soul of Business
      </h1>
      <p class="bookDescription body article font2">
        <p><b>From old-fashioned bricks-and-mortars to cutting-edge startups, businesses are moving into uncharted territory as they determine how to move from an analog past to a digital future effectively. How can you make sure not to leave human instinct behind?</b></p><p>Businesses are leaving behind traditional meetings in favor of virtual ones, transitioning from surveys and studies to analytics and algorithms. The startling and often unacknowledged truth is that?the promise of digital transformation can only be realized when we find a way to balance it with the promise of people.?In the end, it’s the people that matter, and companies must never forget the soul that drives them.</p><p>In <i>Restoring the Soul of Business</i>, business leader Rishad Tobaccowala?teaches you to: </p>Understand how to unleash the significant benefit that can be realized by combining emotion and data, human and machine, analog and digital.Spot the warning signs of data-blinded companies: cold cultures with little human interaction, poor innovation stemming from discouraged employees who don’t contribute ideas, and poor customer service due to automated, robotic processes.Explore how organizations of various sizes and from different industries have successfully reoriented their thinking on how to fuse technology and humanity.Gain skills to become an expert in connections critical to growth and success, including the connection between being creative and using technology.Everyone working in an organization will find penetrating observations and guidance about how and why establishing the proper balance between human intuition and creativity and data-driven insights can lead to increased revenue, profitability, retention—and even joy—in their careers and business.<p><i>Restoring the Soul of Business </i>provides practical tools and techniques that every organization can and should implement, and challenges you to move forward with the kind of balance that capitalizes transformation and produces one great success after another.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rishad Tobaccowala
      </h2>
      
      <p class="authorDescription body article"><P><B>Rishad Tobaccowala</B> is the Chief Growth Officer at Publicis Groupe, an advertising and communications firm whose 80,000 employees worldwide are dedicated to delivering marketing and business transformation. He is responsible for supporting the leaders of Publicis Groupe&rsquo;s largest global clients, to help these organizations grow in a revolutionary time for all businesses. For his pioneering innovation, <I>BusinessWeek</I> named Tobaccowala one of the top business leaders, and he also was dubbed one of five marketing innovators by <I>TIME </I>magazine. He regularly presents keynotes at industry conferences and speaks at well-known global organizations, such as Kellogg&rsquo;s, IBM, Amazon, Google, and Facebook.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsChristianPublishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?634837ee